import { z } from 'zod';

export const UpdateCommentSchema = z.object({
    comment: z.string().max(250, "Le commentaire ne peut pas dépasser 250 caractères").nullish()
        .describe("Le texte du commentaire interne (limité à 250 caractères)"),
});

export type UpdateCommentDto = z.infer<typeof UpdateCommentSchema>;